export default "__VITE_ASSET__BQtCERUY__"